<template>
    <v-skeleton-loader :type="listItems" height="600">

    </v-skeleton-loader>
</template>

<script>
    export default {
        name: "PersonalEditSkeleton",
        computed: {
            listItems(){
                return ['card-heading', 'list-item', 'list-item', 'list-item', 'list-item', 'list-item', 'list-item', ].join(',');
            }
        }
    }
</script>

<style scoped>

</style>
